module.exports = __webpack_public_path__ + "static/media/Erdal.3d20a1dc.jpg";